import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Box,
  Typography,
  FormControl,
  Select,
  MenuItem,
  FormHelperText,
  Button,
  Modal,
  Paper,
  IconButton,
  Checkbox,
  ListItemText,
  OutlinedInput,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { v4 as uuidv4 } from "uuid";
import dayjs from "dayjs";
import {
  fetchData,
  searchfetchQueries,
  postQuery,
  uploadVideoToS3,
} from "../../../../services/BackendServices";
import { useLoading } from "../../../../context/LoadingContext";
import AlertModal from "../../../../pages/Requirement/components/common/AlerModel";

const GenerateFinanceRFQModal = ({
  open,
  onClose,
  rfqData,
  buyerInfo,
  activeUser,
  bankList,
  allProductMaster,
}) => {
  const navigate = useNavigate();
  const { setLoading } = useLoading();
  const [formData, setFormData] = useState({
    instrument: "",
  });
  const [errors, setErrors] = useState({});
  const [selectedBanks, setSelectedBanks] = useState([]);
  const [modal, setModal] = useState({
    show: false,
    type: "info",
    title: "",
    message: "",
    nextAction: null,
    autoClose: null,
  });
  const handleModalClose = () => {
    const action = modal.nextAction;
    setModal((prev) => ({ ...prev, show: false, nextAction: null }));
    if (action) action();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    // Clear error when user selects a valid option
    if (value) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleBankSelectionChange = useCallback((e) => {
    setSelectedBanks(e.target.value);
  }, []);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.instrument) {
      newErrors.instrument = "Financial instrument is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleSubmit = async () => {
    if (!validateForm()) {
      return;
    }
    try {
      setLoading(true)
      // Placeholder for submission logic
      console.log("Submitting Finance RFQ:", {
        rfqData,
        buyerInfo,
        ...formData,
      });
      console.log("buyerInfo##", buyerInfo[0]?.FirstName);
      const curreDate = new Date();
      const defaultShipmentDate = dayjs(curreDate).format("YYYY-MM-DD");
      const reqNoDate = dayjs(curreDate).format("YYYYMMDD");
      let Id = uuidv4();
      let RfqId = "";

      const bodyFRFQ = {
        target: "listFinanceRfq",
        userOrder: "RfqId",
        rowStart: 0,
        pageSize: 1,
      };
      const responseFRFQ = await fetchData(bodyFRFQ);
      let totalItems =responseFRFQ.total || 0;

      const reqCount = totalItems + 1;
      RfqId = reqNoDate + reqCount;

      let LcAmountDerived = 0;
      LcAmountDerived =
        parseFloat(rfqData.Price) * parseFloat(rfqData.Quantity);

      let rfqDeliveryLocation = rfqData.DeliveryLocation || "";
      let [rfqDeliveryCountry, rfqDeliveryPort] =
        rfqDeliveryLocation.split("~");

      let Title = rfqData.Title || " ";
      let Instrument = formData.instrument || " ";
      let ApplicantName =
        buyerInfo[0]?.FirstName + " " + buyerInfo[0]?.LastName;
      let BeneficiaryName = "Agropreneurs Market Technology Pvt Ltd";
      let LcAmount = parseFloat(LcAmountDerived) || 0;
      let Currency = "USD";
      let TypeOfLc = rfqData.lcType || "Sight";
      let Incoterms = rfqData.Incoterm || "n/a";
      let OriginCountry = rfqData.OriginCountry || "n/a";
      let DestinationCountry = rfqDeliveryCountry || "n/a";
      let GoodsDescription = rfqData.goodsDescription || "n/a";
      const requiredDocumentsStr = "Commercial Invoice";
      let ConfirmingBank = rfqData.advisingConfirmingBank || "n/a";
      let LcBankDetails = rfqData.lcOpeningBankDetails || "n/a";
      let ExpiryDate = rfqData.ValidUntil
        ? dayjs(rfqData.ValidUntil).format("YYYY-MM-DD")
        : defaultShipmentDate;
      let ExpiryPlace = rfqData.expiryPlace || "n/a";
      let PaymentTerms = rfqData.paymentTerms || "LC at Sight";
      let TradeType = rfqData.tradeType || "Export";

      let product = "";
      if (rfqData.ProductID) {
        product = allProductMaster.find(
          (p) => p.ProductID === rfqData.ProductID
        );
      }

      let ComodityDescription = product
        ? product.ProductName + "/" + product.Grade
        : "" || "n/a";

      let Hscode = product ? product.HsCode : "";
      let BuyerName =
        buyerInfo[0]?.FirstName +
          " " +
          buyerInfo[0]?.LastName +
          "/" +
          buyerInfo[0]?.Country || "n/a";
      let BuyerCountry =
        buyerInfo[0]?.FirstName +
          " " +
          buyerInfo[0]?.LastName +
          "/" +
          buyerInfo[0]?.Country || "n/a";
      let SellerName = "Agropreneurs Market Technology Pvt Ltd/India";
      let SellerCountry = "Agropreneurs Market Technology Pvt Ltd/India";
      let LoadingPort = rfqData.portLoading || "Kolkata";
      let DischargePort = rfqDeliveryPort || "n/a";
      let TradeIncoterms = rfqData.Incoterm || "n/a";
      let ShipmentDate = rfqData.DeliveryDate
        ? dayjs(rfqData.DeliveryDate).format("YYYY-MM-DD")
        : defaultShipmentDate;
      let TradeValue = parseFloat(LcAmountDerived) || 0;
      let ConfirmingBankRequired = rfqData.advisingConfirmingBankRequired
        ? "Y"
        : "N";
      let ConfirmationRequired = rfqData.confirmationRequired ? "Y" : "N";
      let PartialShipmentAllowed = rfqData.partialShipmentAllowed ? "Y" : "N";
      let TransshipmentAllowed = rfqData.transshipmentAllowed ? "Y" : "N";
      let InstrumentTerms =
        rfqData.instrumentTerms || formData.instrument || " ";
      let ConfirmationCharges = 0;
      let IssuanceCharges = 0;
      let InterestRateMargin = 0;
      let TenorOffered = rfqData.tenorOffered || " ";
      let AdditionalDocuments = rfqData.additionalDocuments || " ";
      let SpecialClause = rfqData.specialConditions || " ";
      let ResponseDeadlineBank = rfqData.responseDeadline
        ? dayjs(rfqData.responseDeadline).format("YYYY-MM-DD")
        : defaultShipmentDate;
      let PreferedFinanceRateType = rfqData.preferredFinancingRateType || " ";
      let MaxAcceptableCharges = rfqData.maximumAcceptableCharges || " ";
      let AdditionalComments = rfqData.AdditionalProductNotes || " ";

      // Upload single file to S3 and get filename
      let proformaInvoiceFileRef = " ";
      let tradeDocsFileRef = " ";
      let kycDocsFileRef = " ";
      let proformaInvoiceFileRefUrl = " ";
      let tradeDocsFileRefUrl = " ";
      let kycDocsFileRefUrl = " ";

      const financeRfqInput = {
        Id: Id,
        RfqId: RfqId,
        Title: Title,
        Instrument: Instrument,
        ApplicantName: ApplicantName,
        BeneficiaryName: BeneficiaryName,
        LcAmount: LcAmount,
        Currency: Currency,
        TypeOfLc: TypeOfLc,
        Incoterms: Incoterms,
        OriginCountry: OriginCountry,
        DestinationCountry: DestinationCountry,
        GoodsDescription: GoodsDescription,
        RequiredDocuments: requiredDocumentsStr,
        ConfirmingBank: ConfirmingBank,
        LcBankDetails: LcBankDetails,
        ExpiryDate: ExpiryDate,
        ExpiryPlace: ExpiryPlace,
        PaymentTerms: PaymentTerms,
        TradeType: TradeType,
        ComodityDescription: ComodityDescription,
        Hscode: Hscode,
        BuyerName: BuyerName,
        BuyerCountry: BuyerCountry,
        SellerName: SellerName,
        SellerCountry: SellerCountry,
        LoadingPort: LoadingPort,
        DischargePort: DischargePort,
        TradeIncoterms: TradeIncoterms,
        ShipmentDate: ShipmentDate,
        TradeValue: TradeValue,
        ConfirmingBankRequired: ConfirmingBankRequired,
        ConfirmationRequired: ConfirmationRequired,
        PartialShipmentAllowed: PartialShipmentAllowed,
        TransshipmentAllowed: TransshipmentAllowed,
        InstrumentTerms: InstrumentTerms,
        ConfirmationCharges: ConfirmationCharges,
        IssuanceCharges: IssuanceCharges,
        InterestRateMargin: InterestRateMargin,
        TenorOffered: TenorOffered,
        AdditionalDocuments: AdditionalDocuments,
        SpecialClause: SpecialClause,
        ProformaInvoiceFile: proformaInvoiceFileRef || "",
        TradeDocumentFile: tradeDocsFileRef || "",
        KycDocumentFile: kycDocsFileRef || "",
        ResponseDeadlineBank: ResponseDeadlineBank,
        PreferedFinanceRateType: PreferedFinanceRateType,
        MaxAcceptableCharges: MaxAcceptableCharges,
        AdditionalComments: AdditionalComments,
        CreatedBy: activeUser,
        Status: "Draft",
      };
      const body = {
        target: "createFinanceRfq",
        financeRfqInput,
      };
      const result = await postQuery(body);
      if (!result || !result.items)
        throw new Error(`Failed to create finance RFQ.`);

      const selectedBanksData = selectedBanks.map((id) => ({
        BankID: id,
      }));
      const bankPromises = selectedBanksData.map(async (bank) => {
        const financeRfqBanksInput = {
          FinanceRfqBankID: uuidv4(),
          FinanceRfqID: result.items.Id || Id, // Use Id from response or fallback to generated Id
          BankID: bank.BankID,
        };
        const bankBody = {
          target: "createFinanceRfqBanks",
          financeRfqBanksInput,
        };
        await postQuery(bankBody);
      });

      // Execute all bank API calls in parallel
      await Promise.all(bankPromises).catch((error) => {
        console.error("Error creating FinanceRfqBanks:", error);
        throw new Error("Failed to associate banks with RFQ.");
      });
      console.error("Submission success:", result);
      setFormData({ instrument: "" });
      setErrors({});
      setModal({
        show: true,
        type: "success",
        title: "Success!",
        message: `Finance RFQ ${RfqId} created successfully.`,
        autoClose: false,
      });
    } catch (error) {
      console.error("Submission error:", error);
      setModal({
        show: true,
        type: "error",
        title: "Error!",
        message: error.message || `Failed to create finamce RFQ.`,
        autoClose: false,
      });
    } finally {
      onClose(); // Close modal after submission
      setLoading(false)
    }
  };

  

  return (
    <div className="container">
      <AlertModal
        type={modal.type}
        title={modal.title}
        message={modal.message}
        showModal={modal.show}
        onClose={handleModalClose}
        buttonText="OK"
        autoClose={modal.autoClose}
      />
      <Modal open={open} onClose={onClose}>
        <Paper
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 550,
            p: 4,
            bgcolor: "background.paper",
            boxShadow: 24,
          }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
            <Typography variant="h6">Generate Finance RFQ</Typography>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box>
            <Typography variant="body2" sx={{ mb: 1 }}>
              {/* RFQ ID: {rfqId} */}
            </Typography>
            <div className="select-filter-box">
              <FormControl fullWidth error={!!errors.instrument}>
                <Typography
                  sx={{
                    width: "100%",
                    color: "#de6b14",
                    fontSize: "14px",
                  }}
                  variant="body2"
                >
                  Select Instrument *
                </Typography>
                <Select
                  name="instrument"
                  value={formData.instrument || ""}
                  onChange={handleChange}
                  size="small"
                  placeholder="Select Instrument"
                  sx={{
                    backgroundColor: "white",
                    borderRadius: "4px",
                    "& .MuiSelect-select": { padding: "8px 14px" },
                    minWidth: 400,
                  }}
                  inputProps={{ "aria-label": "Select Instrument" }}
                >
                  <MenuItem value="" disabled>
                    Select Instrument
                  </MenuItem>
                  {[
                    "Letter of Credit (LC) - Sight / Usance / Back-to-Back",
                    "Deferred Payment Terms with LC",
                    "Bank Guarantee (BG) - Payment / Performance",
                    "Standby Letter of Credit (SBLC)",
                    "Buyer's Credit / Trade Loan",
                    "Documentary Collection (D/P or D/A)",
                    "Open Account with Credit Insurance",
                  ].map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>

                {errors.instrument && (
                  <FormHelperText>{errors.instrument}</FormHelperText>
                )}
              </FormControl>
              <FormControl fullWidth sx={{ mb: 3 }}>
                <Typography variant="body2">Select Banks *</Typography>
                <Select
                  multiple
                  value={selectedBanks}
                  onChange={handleBankSelectionChange}
                  input={<OutlinedInput />}
                  renderValue={(selected) =>
                    selected
                      .map(
                        (id) =>
                          bankList.find((bank) => bank.BankID === id)?.BankName
                      )
                      .join(", ")
                  }
                  sx={{ backgroundColor: "white" }}
                >
                  {bankList.map((bank) => (
                    <MenuItem key={bank.BankID} value={bank.BankID}>
                      <Checkbox checked={selectedBanks.includes(bank.BankID)} />
                      <ListItemText primary={bank.BankName} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
            <Button
              variant="contained"
              onClick={handleSubmit}
              sx={{
                backgroundColor: "#ff9800",
                "&:hover": { backgroundColor: "#fb8c00" },
              }}
            >
              Submit
            </Button>
          </Box>
        </Paper>
      </Modal>
    </div>
  );
};
export default GenerateFinanceRFQModal;
